import Carousel from '../Carousel/carousel'

const ProductPage = ({ projectImages }) => {
  return (
    <Carousel images={projectImages} />
  )
}

export default ProductPage
